import React, { useEffect, useState } from 'react'

const Appads = () => {
  function FileReadExample() {
    const [fileContent, setFileContent] = useState('');

    useEffect(() => {
      fetch('/app-ads.txt')  // Adjust the path as needed
        .then((response) => response.text())
        .then((data) => setFileContent(data));
    }, []);
  
    return (
      <div>
        <pre>{fileContent}</pre>
      </div>
    );
  }
}

export default Appads
